/* eslint-disable react-native/no-inline-styles */
import {Button, Card, Layout, Modal, Text} from '@ui-kitten/components';
import React from 'react';
import {StyleSheet} from 'react-native';
import {isLandscape, px, wp} from '../../../utils';

const ConfirmPurchaseModal = ({title, text, visible, onClose}) => {
  return (
    <Modal
      visible={visible}
      backdropStyle={styles.backdrop}
      onBackdropPress={onClose}>
      <Card disabled={true}>
        <Layout style={styles.container}>
          <Text style={styles.thankYou}>{title}</Text>
          <Text style={styles.text}>{text}</Text>
          <Button style={{marginTop: 62}} onPress={() => onClose()}>
            {'Okay'}
          </Button>
        </Layout>
      </Card>
    </Modal>
  );
};

const styles = StyleSheet.create({
  container: {
    height: 'auto',
    width: isLandscape() ? wp(30) : wp(90),
    paddingTop: 68,
    paddingBottom: 39,
    paddingHorizontal: 29,
  },
  backdrop: {
    backgroundColor: 'rgba(255, 255, 255, 0.5)',
  },
  title: {
    width: '100%',
    fontSize: px(16),
    marginBottom: px(15),
  },
  thankYou: {
    fontWeight: '600',
    fontSize: 20,
    textAlign: 'center',
  },
  text: {
    fontSize: 16,
    textAlign: 'center',
    marginTop: px(24),
  },
});

export default ConfirmPurchaseModal;
